<template>
    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <inertia-link
            :href="route('nl.employerdashboard.settings.overview', this.$page.props.auth.user.selected_company.uuid)"
            class="nav-link font-poppins color-blue font-size-18 col-12 py-3 px-3 px-md-4 border-bottom"
            :class="isActive('general') ? 'active' : ''">
            {{ Lang.get('employerdashboard::pages/settings/index.tabs.general') }}</inertia-link>
        <inertia-link
            :href="route('nl.employerdashboard.settings.provider.status', this.$page.props.auth.user.selected_company.uuid)"
            class="nav-link font-poppins color-blue font-size-18 col-12 py-3 px-3 px-md-4 border-bottom"
            :class="isActive('provider') ? 'active' : ''">
            {{ Lang.get('employerdashboard::pages/settings/index.tabs.provider') }}</inertia-link>
        <inertia-link
            v-if="$page.props.adminManagementIsVisible"
            :href="route('nl.employerdashboard.settings.admin.overview', this.$page.props.auth.user.selected_company.uuid)"
            class="nav-link font-poppins color-blue font-size-18 col-12 py-3 px-3 px-md-4 border-bottom"
            :class="isActive('admins') ? 'active' : ''">
            {{ Lang.get('employerdashboard::pages/settings/index.tabs.admins') }}</inertia-link>
        <inertia-link
            v-if="$page.props.profileIsVisible"
            :href="route('nl.employerdashboard.settings.profile', this.$page.props.auth.user.selected_company.uuid)"
            class="nav-link font-poppins color-blue font-size-18 col-12 py-3 px-3 px-md-4 border-bottom"
            :class="isActive('profile') ? 'active' : ''">
            {{ Lang.get('employerdashboard::pages/settings/index.tabs.profile') }}</inertia-link>
        <inertia-link
            v-if="$page.props.profileIsVisible"
            :href="route('nl.employerdashboard.settings.two-factor-authentication.start.show', this.$page.props.auth.user.selected_company.uuid)"
            class="nav-link font-poppins color-blue font-size-18 col-12 py-3 px-3 px-md-4 border-bottom"
            :class="isActive('two-factor-authentication') ? 'active' : ''">
            {{ Lang.get('employerdashboard::pages/settings/index.tabs.two_factor_authentication') }}</inertia-link>
    </div>
</template>

<script>
export default {

    props: {
        tab: String,
    },
    methods: {
        isActive(tab) {
            return tab === this.tab;
        },
    },
}
</script>
